// extracted by mini-css-extract-plugin
module.exports = {"error":"Login_error__25Eh1","warningBlock":"Login_warningBlock__QIBvy","warningText":"Login_warningText__QFN97"};